import { useCallback, useRef, useSyncExternalStore } from 'react';
import {
  readWaiterCartRecoveryRaw,
  readWaiterCartRecoveryView,
  type WaiterCartRecovery,
} from './waiterCartSlice';

function subscribeToStorage(onChange: () => void): () => void {
  window.addEventListener('storage', onChange);
  return () => window.removeEventListener('storage', onChange);
}

/**
 * DF-0383 — ce que d'autres onglets de cet appareil ont laissé pour cette
 * table, tenu à jour : un autre onglet qui récupère ou supprime ces plats les
 * retire d'ici aussitôt (événement `storage`), et une écriture de cet onglet-ci
 * se voit au rendu qu'elle provoque. Sans cela, deux tickets ouverts sur la
 * même copie la proposaient encore après que l'un l'avait envoyée.
 */
export function useWaiterCartRecovery(sessionUuid: string): WaiterCartRecovery {
  const cache = useRef<{ sessionUuid: string; raw: string; value: WaiterCartRecovery } | null>(null);
  const getSnapshot = useCallback(() => {
    const raw = readWaiterCartRecoveryRaw(sessionUuid);
    if (!cache.current || cache.current.sessionUuid !== sessionUuid || cache.current.raw !== raw) {
      cache.current = { sessionUuid, raw, value: readWaiterCartRecoveryView(sessionUuid) };
    }
    return cache.current.value;
  }, [sessionUuid]);
  return useSyncExternalStore(subscribeToStorage, getSnapshot);
}
